<!-- <app-table-standard-layout [dataSource$]="transactions$" [title]="'Transactions'" [columnSettings]="columnSettings" ></app-table-standard-layout> -->


<app-container-standard title="Transaction filter">
  <form #f="ngForm" (ngSubmit)="onSubmit(f.value)">
      <div class="form-row">
         
          <div class="form-group col-md-4">
              <mat-form-field>
                  <mat-select placeholder="Select time period" [(value)]="timeSelected"
                      (selectionChange)="setTimePeriodeEvent($event)">
                      <mat-option >select</mat-option>
                      <mat-option value="TODAY" >Today</mat-option>
                      <mat-option value="YESTERDAY">Yesterday</mat-option>
                      <mat-option value="24H">Last 24 hours</mat-option>
                      <!-- <mat-option value="THIS_WEEK">This week</mat-option>
                      <mat-option value="LAST_WEEK">Last week</mat-option> -->
                      <mat-option value="THIS_MONTH">This month</mat-option>
                      <mat-option value="LAST_MONTH">Last month</mat-option>
                      <mat-option value="CUSTOM">Customized</mat-option>
                  </mat-select>
              </mat-form-field>
          </div>

      </div>
      <!-- timeSelected == 'CUSTOM' -->
      <!-- <ng-container *ngIf="timeSelected == 'CUSTOM'">
          <mat-label>Custom time periode:</mat-label><br>
          <div class="form-row" *ngIf="inputDateFrom"> -->
                  <!-- <angular2-date-picker [(ngModel)]="inputDateFrom" name="fromDatePricker" [settings]="settings"></angular2-date-picker> -->

              <!-- <div class="form-group col-md-4">
                  <span class="datetime-picker-label">Date from</span><br>
                  <input class="datetime-picker" [(ngModel)]="inputDateFrom" name="dataFrom" [owlDateTime]="dt2" placeholder="Date Time">
                  <span [owlDateTimeTrigger]="dt2" class="date-icon"><i class="fa fa-calendar"></i></span>
                  <owl-date-time firstDayOfWeek="1" #dt2></owl-date-time>
              </div>
              <div class="form-group col-md-4">
                      <span class="datetime-picker-label">Date to</span><br>
                      <input class="datetime-picker" [(ngModel)]="inputDateTo" name="dateTo" [owlDateTime]="dt3" placeholder="Date Time">
                      <span [owlDateTimeTrigger]="dt3" class="date-icon"><i class="fa fa-calendar"></i></span>
                      <owl-date-time firstDayOfWeek="1" #dt3></owl-date-time>
                  </div>
                   -->
                   <div class="form-group col-md-4">
                    <ng-container *ngIf="timeSelected == 'CUSTOM'">
                        <mat-form-field>
                          <mat-label>Custom Date Range</mat-label>
                          <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start date" (dateChange)="setCustomRange($event, 'start')">
                            <input matEndDate placeholder="End date" (dateChange)="setCustomRange($event, 'end')">
                          </mat-date-range-input>
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                      </ng-container>
                    </div>
          <!-- </div>
      </ng-container> -->
      <div class="example-button-row">
          <button type="button" class="theme-gray gray-text" style="visibility: hidden;" mat-flat-button >Reset</button>
          <button type="submit"  class="theme-primary white-text float-right" [disabled]="!timeSelected" mat-flat-button>Get</button>
      </div>
  </form>
</app-container-standard>
<router-outlet></router-outlet>